import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { StepperContext } from "@natera/stepper";

import TimeslotsForm from "@app/components/forms/timeslotsForm/timeslotsForm";
import { StepperContent } from "@app/components/ui/layout";
import StepperHeaderProgress from "@app/components/stepperHeaderProgress";
import TimeslotsDescription from "@app/components/sampleDraw/mobilePhlebotomy/timeslotsDescription/timeslotsDescription";
import { SpecificDatesProvider } from "@app/provider";

const messages = defineMessages({
  mobilePhlebotomyTimeslotsTitle: {
    id: "mobilePhlebotomyTimeslotsTitle",
    defaultMessage: "Mobile Blood Draw",
  },
  mobilePhlebotomyTimeslotsDescriptionTitle: {
    id: "mobilePhlebotomyTimeslotsDescriptionTitle",
    defaultMessage: "When are some good times for your blood draw?",
  },
  mobilePhlebotomyTimeslotsNext: {
    id: "mobilePhlebotomyTimeslotsNext",
    defaultMessage: "Next",
  },
});

const Timeslots: FC = () => {
  const intl = useIntl();
  const { goBack, resolve } = React.useContext(StepperContext);

  return (
    <>
      <StepperHeaderProgress />
      <StepperContent
        title={intl.formatMessage(messages.mobilePhlebotomyTimeslotsTitle)}
        subTitle={intl.formatMessage(
          messages.mobilePhlebotomyTimeslotsDescriptionTitle
        )}
        description={<TimeslotsDescription />}
      >
        <SpecificDatesProvider>
          <TimeslotsForm
            handleBack={goBack}
            handleConfirm={resolve}
            confirmButtonLabel={intl.formatMessage(
              messages.mobilePhlebotomyTimeslotsNext
            )}
          />
        </SpecificDatesProvider>
      </StepperContent>
    </>
  );
};

export default Timeslots;
